import base64 from 'base-64'

const utils = {
	decode(dataStr) {
		try {
			if (typeof dataStr !== "string") {
				throw new Error("Data invalid.")
			}
			let dataBase64 = base64.decode(dataStr)
			return decodeURIComponent(dataBase64)
		} catch (error) {
			return ""
		}
	},
	encode(dataStr) {
		try {
			if (typeof dataStr !== "string") {
				throw new Error("Data invalid.")
			}
			let dataUTF8 = encodeURIComponent(dataStr)
			return base64.encode(dataUTF8)
		} catch (error) {
			console.error(error)
			return ""
		}
	},
	arrayDiff(arrayA, arrayB) {
		if (!Array.isArray(arrayA)) {
			return []
		}
		if (!Array.isArray(arrayB)) {
			return arrayA
		}

		return arrayA.filter(a => {
			let b = arrayB.find(b => b === a)
			return !b
		})
	},
	downloadFile(data, type, name) {
		try {
			if (!data || !type || !name) {
				throw new Error("Data not found.")
			}
			let blob = null
			try {
				// array buffer to JSON
				var decodedString = String.fromCharCode.apply(null, new Uint8Array(data));
				JSON.parse(decodedString);
			} catch (error) {
				blob = new Blob(
					[data],
					{ type: type }
				)
			}
			if (!blob) {
				throw new Error("[NO BLOB]")
			}
			// Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
			const blobUrl = URL.createObjectURL(blob);

			// Create a link element
			const link = document.createElement("a");

			// Set link's href to point to the Blob URL
			link.href = blobUrl;
			link.download = name;

			// Append link to the body
			document.body.appendChild(link);

			// Dispatch click event on the link
			// This is necessary as link.click() does not work on the latest firefox
			link.dispatchEvent(
				new MouseEvent('click', {
					bubbles: true,
					cancelable: true,
					view: window
				})
			);

			// Remove link from body
			document.body.removeChild(link);
		} catch (error) {
			console.error("Dowload file fail", error.message)
		}
	},
}

export default utils


// WEBPACK FOOTER //
// ./src/core/utility/utils.js